export default __webpack_public_path__ + "static/desktop_10-5a672fda39e7ff73824bdf904ed2feec.webp";